import React, { useEffect, useState } from 'react'
import { useQuizContext } from '../context/QuizContext'
import { quiz } from '../quizdata';
import { ToastContainer, toast } from 'react-toastify';
import { addLeadingZero } from '../helpers';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { Container } from 'react-bootstrap';
import ListGroup from 'react-bootstrap/ListGroup';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import CountDown, { formatTime } from './CountDown';

const totalAttempt = 3;
const initialResultState = {
    score: 0,
    correctAnswers: 0,
    wrongAnswers: 0,
    takeTime: 0
}

const Quiz = () => {
    const { username, countDown, setCountDown, showResult, setShowResult, takeTime, setTakeTime, seconds } = useQuizContext();
    const [currentQuestion, setCurrentQuestion] = useState(0)
    const [selectedAnswer, setSelectedAnswer] = useState('')
    const [result, setResult] = useState(initialResultState)
    const [attempt, setAttempt] = useState(0);
    const [selectedAnswerIndex, setSelectedAnswerIndex] = useState(null);
    const [startselected,setStartSelected]=useState(false);
    
    const { questions,perQuestionScore ,topic ,level,totalQuestions} = quiz;
    const { question, choices, correctAnswer } = questions[currentQuestion]

    const onClickPrev = () => {
        setCurrentQuestion((old) => old - 1)
    }

    //handling NextButton Functionality----->when click on nex button make a result 
    const onClickNext = () => {
        setResult((old) =>
            selectedAnswer ?
                {
                    ...old,
                    score: old.score + perQuestionScore,
                    correctAnswers: old.correctAnswers + 1
                } :
                {
                    ...old,
                    wrongAnswers: old.wrongAnswers + 1
                }

        )
        //next button displayed!
        if (currentQuestion !== questions.length - 1) {
            setCurrentQuestion((old) => old + 1)
            setSelectedAnswerIndex(null);
        }
       //finish Quiz
        else {
            setCurrentQuestion(0)
            toast.success("Thank you for submitting quiz!")
            setShowResult(true);
            setResult((old) => ({ ...old, takeTime: formatTime(takeTime) }));
            setAttempt((old) => old + 1);
        }
        console.log("result", result)
    }

    //list button --when click on answer button
    const onAnswerSelected = (answer, index) => {
        setStartSelected(true)
        setSelectedAnswerIndex(index);

        if (answer === correctAnswer) {
            setSelectedAnswer(true);
            console.log("right");
        }
        else {
            setSelectedAnswer(false);
            console.log("wrong")

        }

    }

    return (
        <>
            <div className="quiz-container">
                <Container className='mt-4'>
                    <Card>
                        {!showResult ? (
                            <>
                            {/* Quiz sections */}
                                <div className="container d-flex justify-content-between">
                                    <h2 className='m-3'>Quiz of {topic} </h2>
                                    <h2 className='m-3'>Level : {level} </h2>
                                    <h2 className='m-3'><CountDown start={startselected} /></h2>
                                </div>
                                <Card.Header className='m-3 questionHeader'> Question Attempted:<span className="question-Attempted">
                                {addLeadingZero(currentQuestion)}</span>/
                                    <span className="question-total">{addLeadingZero(totalQuestions)}</span></Card.Header>
                                <Card.Body>
                                    <Card.Title>Question:</Card.Title>
                                    <Card.Text>
                                        {question}
                                    </Card.Text>
                                    <Card.Subtitle>
                                        <ListGroup className='p-4 list-group'>
                                            {choices.map((answer, index) => (
                                                <ListGroup.Item style={{ padding: "15px", cursor: "pointer" }} onClick={() => onAnswerSelected(answer, index)} key={answer}
                                                    className={selectedAnswerIndex === index ? 'selected-answer' : null}
                                                >{answer}</ListGroup.Item>
                                            ))}
                                        </ListGroup>
                                    </Card.Subtitle>
                                    <div className="container d-flex justify-content-between">
                                        <Button variant='success' onClick={onClickPrev} disabled={currentQuestion === 0}><ArrowBackIosNewIcon /></Button>
                                        <Button variant="success" onClick={onClickNext} disabled={selectedAnswerIndex === null}>
                                            {currentQuestion === questions.length - 1 ? <CheckCircleOutlineIcon /> : <NavigateNextIcon />}
                                        </Button>
                                    </div>


                                </Card.Body>
                            </>
                        ) : (
                            <>
                            {/* result section  */}
                                <Card.Header as="h5" className='m-3 p-5'>Result</Card.Header>
                                <Card.Body className='p-4 resultcard'>
                                    <ListGroup variant="flush" className='m-3 resultListgrp'>
                                        <ListGroup.Item>Total Question: <span>{questions.length}</span></ListGroup.Item>
                                        <ListGroup.Item>Total Score:<span> {result.score}</span></ListGroup.Item>
                                        <ListGroup.Item>Correct Answers:<span> {result.correctAnswers}</span></ListGroup.Item>
                                        <ListGroup.Item> Wrong Answers:<span> {result.wrongAnswers}</span></ListGroup.Item>
                                        <ListGroup.Item>Attempt:<span> {attempt}</span></ListGroup.Item>
                                        <ListGroup.Item> TakeTime:<span> {result.takeTime}</span></ListGroup.Item>
                                    </ListGroup>
                                    <Button variant='primary' onClick={() => {
                                        setShowResult(false);
                                        setSelectedAnswerIndex(null);
                                        toast.warn(`Now you can reattempt ${totalAttempt - attempt} more times!`);
                                        setCountDown(seconds);
                                        setResult(initialResultState);
                                        setTakeTime(0);
                                    }}
                                        disabled={attempt === 3}>ReAttempted</Button>
                                </Card.Body>
                            </>
                        )}
                    </Card>
                </Container>
            </div>
            <ToastContainer />
        </>

    )
}

export default Quiz